module.exports = __webpack_public_path__ + "fonts/iconfont.0d3bde1d.eot";